import { ChangeEvent, ReactNode, useId, useRef } from 'react';

import styles from './Select.module.scss';

interface Props {
  addon?: ReactNode;
  children: ReactNode;
  disabled?: boolean;
  grow?: boolean;
  label?: string;
  name?: string;
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
  required?: boolean;
  value?: string;
  width?: string;
}

export function Select({
  addon,
  children,
  disabled,
  grow,
  label,
  name,
  onChange = () => undefined,
  required,
  value,
  width,
}: Props) {
  const selectRef = useRef<HTMLSelectElement>(null);
  const id = useId();

  const onClickContainer = () => {
    if (selectRef.current) {
      selectRef.current.focus();
    }
  };

  const componentClassName = [styles['select'], grow && styles['select-grow']]
    .filter(Boolean)
    .join(' ');
  const labelClassName = [styles['select-label']].filter(Boolean).join(' ');
  const selectClassName = [styles['select-element']].filter(Boolean).join(' ');

  return (
    <div
      className={componentClassName}
      onClick={onClickContainer}
      style={{ width }}
    >
      {label && (
        <label className={labelClassName} htmlFor={id}>
          {label}
        </label>
      )}
      <select
        ref={selectRef}
        className={selectClassName}
        disabled={disabled}
        id={id}
        name={name}
        onChange={onChange}
        required={required}
        value={value}
      >
        {children}
      </select>
      {addon && <div>{addon}</div>}
    </div>
  );
}
